import { Typography } from "@mui/material";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { Trans } from "react-i18next";
import { renderDate } from "utils/formatter";

interface IProps {
  i18nKey: string;
  date?: string;
  color?: string;
}

const StatusInfoLine = ({ i18nKey, date, color }: IProps) => {
  const { colors } = useMUIThemeModeContext();

  const defaultColor = color || colors.gray600;
  const formattedDate = date ? renderDate(date) : "-";

  return (
    <Typography fontWeight={fontWeight.light} fontSize={{ xs: "0.75rem", sm: "0.875rem" }} color={defaultColor}>
      <Trans
        i18nKey={i18nKey}
        values={{ date: formattedDate }}
        components={{
          t: (
            <span
              style={{
                fontWeight: fontWeight.medium,
                fontSize: "inherit",
                whiteSpace: "nowrap",
              }}
            />
          ),
        }}
      />
    </Typography>
  );
};

export default StatusInfoLine;